module.exports = __webpack_public_path__ + "img/button-arrow.21ec47ad.svg";